/**
 * @param {string} prompt 
 * @returns Promise<Object | void>
 */
export default async function getAdressCoordinates(prompt) {
	if (!prompt) return;

	const req = await fetch(
		`/api/get_coordinates/?${new URLSearchParams({
			input_text: prompt,
			get_coordinates: '1'
		})}`
	);
	const res = await req.json();

	return res;
}
